import React, { useEffect, useState } from "react";
import { Grid, IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { useTranslation } from "react-i18next";
import { useDebounce } from "../../shared/technical/hooks/useDebounce";

export interface CompaniesListFilters {
  search?: string;
}

export function filtersToQueryString(filters: CompaniesListFilters): string {
  const parts: string[] = [];
  if (filters.search) parts.push(`search=${encodeURIComponent(filters.search)}`);
  return parts.join('&');
}

export function CompaniesListFiltersBar(props: {
  onFiltersChange: (filters: CompaniesListFilters) => void;
}) {
  const { onFiltersChange } = props;
  const { t } = useTranslation();

  const [searchInput, setSearchInput] = useState('');
  const debouncedSearch = useDebounce(searchInput, 300);

  useEffect(() => {
    onFiltersChange({
      search: debouncedSearch.trim() || undefined,
    });
  }, [debouncedSearch, onFiltersChange]);

  const hasActiveFilter = !!searchInput;

  const handleReset = () => {
    setSearchInput('');
  };

  return (
    <Grid container={true} justifyContent="center" sx={{ marginTop: 2, marginBottom: 1 }}>
      <Grid item={true} xs={12}>
        <Grid container={true} spacing={2} alignItems="flex-start">
          <Grid item={true} xs={12} sm={true}>
            <TextField
              fullWidth
              size="small"
              label={t('buttons.search') as string}
              value={searchInput}
              onChange={e => setSearchInput(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item={true} xs="auto" sx={{ pt: 0.5 }}>
            <Tooltip title={t('buttons.resetFilters') as string}>
              <span>
                <IconButton onClick={handleReset} disabled={!hasActiveFilter}>
                  <FilterAltOffIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
